import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import {
    ProgramCardCollectionComponent,
    ProgramCardComponent
} from './components';
import { ProgramComponent } from './pages';
import { ProgramRoutingModule } from './program-routing.module';

@NgModule({
    declarations: [
        ProgramCardComponent,
        ProgramCardCollectionComponent,
        ProgramComponent
    ],
    imports: [CommonModule, ProgramRoutingModule, SharedModule]
})
export class ProgramModule {}
